import { useMemo } from 'react';
import dayjs from 'dayjs';
import { DEFAULT_TIME_FIELD_SCROLL_TO_TIME } from '../constants';

// Rounds time to next 15 minute interval, 2:18 PM -> 2:30 PM, 2:00 PM -> 2:00 PM
const roundToNext15Minutes = (time: dayjs.Dayjs) => {
  const minutes = time.minute();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  return time.minute(roundedMinutes).second(0).format('hh:mm A');
};

export const useGetTimeFieldStartTime = ({ date, locationId }: { date?: string; locationId: string }) => {
  const startTime = useMemo(() => {
    if (!date || !locationId) return DEFAULT_TIME_FIELD_SCROLL_TO_TIME;

    const selectedDate = dayjs(date);
    const isToday = selectedDate.isSame(dayjs(), 'day');
    const now = dayjs();

    if (isToday) {
      const nextRounded = roundToNext15Minutes(now);

      return nextRounded;
    } else {
      return DEFAULT_TIME_FIELD_SCROLL_TO_TIME;
    }
  }, [date, locationId]);

  return dayjs(startTime, 'hh:mm A').format('HH:mm:ss');
};
